import { useContext } from 'react';
import { AuthContext } from 'context/Auth';

const useAuthContext = () => {
  return useContext(AuthContext);
}

export { useAuthContext };